import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
// 暂无官方 th_TH，临时沿用 enUS 或后续引入社区包

const root = ReactDOM.createRoot(document.getElementById('root'));
const lang = (localStorage.getItem('lang') || 'zh');
const antdLocale = lang.startsWith('zh') ? zhCN : enUS;

root.render(
  <React.StrictMode>
    <ConfigProvider locale={antdLocale}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
